"use client";

import { cn } from "../../lib/utils";
import { skeletonVariants, SKELETON_STYLES } from "./constants";
import { SkeletonProps, SkeletonSectionProps, SkeletonContainerProps } from "./types";

function Skeleton({
  className,
  variant,
  size,
  ...props
}: SkeletonProps) {
  return (
    <div
      className={cn(skeletonVariants({ variant, size }), className)}
      {...props}
    />
  );
}

const SkeletonSection = ({
  height,
  className = "",
  rounded = true,
}: SkeletonSectionProps) => (
  <div
    className={cn(
      SKELETON_STYLES.section,
      rounded && SKELETON_STYLES.rounded,
      height,
      className
    )}
  />
);

const SkeletonContainer = ({
  sections,
  children,
  className = "",
}: SkeletonContainerProps) => {
  return (
    <div className={className}>
      {children}
      {sections.map((section, index) => (
        <SkeletonSection
          key={index}
          height={section.height}
          className={section.className}
          rounded={section.rounded}
        />
      ))}
    </div>
  );
};

export { Skeleton, SkeletonSection, SkeletonContainer, skeletonVariants };
